import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import Icon from '../icon/Icon';

/**
 * Modale generico del Design System per contenuti arbitrari (form, dettagli).
 * Condivide lo stile di `AppConfirmDialog` (header navy con badge icona +
 * titolo, MUI Dialog) così tutti i modali dell'app sono coerenti. A differenza
 * di `AppConfirmDialog` non impone un footer conferma/annulla: il contenuto
 * porta le proprie azioni.
 *
 * Props:
 *   open      — visibilità
 *   onClose   — callback chiusura (backdrop / Esc / X)
 *   title     — testo header
 *   icon      — classe FontAwesome del badge (default "fa-solid fa-circle-info")
 *   variant   — famiglia semantica del badge (default "primary")
 *   maxWidth  — larghezza MUI (default "md")
 *   children  — corpo del modale
 */
export default function AppModal({
  open,
  onClose,
  title,
  icon = 'fa-solid fa-circle-info',
  variant = 'primary',
  maxWidth = 'md',
  children,
}) {
  return (
    <Dialog open={!!open} onClose={onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: 'var(--radius-md)',
            background: `var(--color-${variant}-container)`,
            color: `var(--color-${variant})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 15,
            flexShrink: 0,
          }}
        >
          <i className={icon} />
        </Box>
        <Box sx={{ fontSize: 16, fontWeight: 700, color: 'var(--color-primary)', flex: 1 }}>
          {title}
        </Box>
        {onClose && (
          <IconButton aria-label="Chiudi" onClick={onClose} size="small" sx={{ flexShrink: 0 }}>
            <Icon name="close" style={{ fontSize: 16 }} />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent dividers sx={{ pt: 2 }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
